import { action, computed } from 'mobx';
import { SignInRepository } from '../repositories/SignInRepository';

export interface ISignInModalErrorControllerConfig {
    signInRepository: SignInRepository;
}

export class SignInModalErrorController {
    private signInRepository: SignInRepository;

    constructor(config: ISignInModalErrorControllerConfig) {
        this.signInRepository = config.signInRepository;
    }

    @computed
    public get data() {
        return {
            isUserLocked: this.signInRepository.isUserLocked,
            apiError: this.signInRepository.apiError
        };
    }

    @action
    public closeModalError = () => {
        this.signInRepository.closeModalError();
    };
}
